module.exports = __webpack_public_path__ + "static/img/image072.94672b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image072.png
// module id = Mha1
// module chunks = 1